/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 09/04/2018.
*
* evaluation-finish Vue Component
*/
<template>
  <el-dialog
    :visible.sync="showDialog"
    custom-class="ms-dialog-evaluation-finish"
    width="60%"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <el-container>
      <el-aside width="250px">
        <div class="aside-container">
          <div>
            <div class="progress-wrapper">
              <div class="progress-container">
                <el-progress
                  type="circle"
                  :percentage="percentage"
                  color="#E02119"
                  :stroke-width="10"
                  :show-text="false"
                  :width="160"/>
              </div>
              <span class="score-label">{{ score }}</span>
            </div>
            <p class="score-message">Tu score <span>{{ score }}/{{ baseScore }}</span></p>
          </div>
        </div>
      </el-aside>
      <el-main>
        <h1>La encuesta ha finalizado.</h1>
        <p class="evaluation-saved-info">La información ha sido guardada y procesada.</p>
        <el-rate
          v-model="evaluationValue"
          disabled
          show-score
          text-color="#ff9900"
          :colors="['#E02119', '#E02119', '#E02119']"
          score-template=""/>
        <p class="evaluation-finish-second-message">La encuesta será enviada a tu correo.</p>
        <el-button
          type="secondary"
          @click="onClose">Cerrar </el-button>
        <el-button
          type="primary"
          @click="onSend">Enviar encuesta</el-button>
      </el-main>
    </el-container>
  </el-dialog>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
export default {
  name: 'EvaluationFinish',
  props: {
    baseScore: {
      type: Number,
      default: 20
    },
    score: {
      type: Number,
      default: 18
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showDialog: this.show
    }
  },
  computed: {
    percentage () {
      return (this.score / this.baseScore) * 100
    },
    evaluationValue () {
      return Math.floor(this.score / this.baseScore * 5)
    }
  },
  methods: {
    onClose () {
      this.showDialog = false
      this.$emit('close')
    },
    handleClose (done) {
      this.$emit('close')
      done()
    },
    onSend () {
      this.showDialog = false
      this.$emit('share-evaluation')
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss">
.ms-dialog-evaluation-finish{
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
  }
  .el-aside{
    border-right: 1px solid #dddddd;
    .progress-wrapper{
      position: relative;
      .score-label{
        @include font-primary(36px, ligth);
        color: $color-ui-primary;
        min-width: 120px;
        position: absolute;
        text-align: center;
        top: 50%;
        left: 50%;
        margin-top: -18px;
        margin-left: -60px;
      }
    }
    .aside-container{
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      p{
        @include font-primary(15px, bold);
        color: #666666;
        text-align: center;
        span{
          font-weight: 400;
        }
      }
    }
  }
  .el-main{
    padding: 50px 30px;
    h1{
      color: $color-ui-primary;
      margin: 0;
      margin-bottom: 10px;
    }
    .evaluation-saved-info{
      color: $color-font-disabled;
    }
    .evaluation-finish-second-message{
      margin-bottom: 40px;
    }
    .el-rate{
      height: 35px;
    }
    .el-rate__icon{
      font-size: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-finish.vue